exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buildSection__navigation__topics.ui.list{padding:15px}.buildSection__navigation__topics.ui.list .pageNumber{margin-top:10px}", ""]);

